<template>
  <div class="lm_pop">

      <!-- 推荐 -->
     <div v-if="yourCommend" @click="handleApplyFor(yourCommend)" class="maxBox">
            <!--      <h1>智能匹配</h1>-->
            <div class="max-container" style="text-align: center">
                <van-image class="back-image" :src="bankCardImage" />
                <div class="bank-info">
                <!-- <div class="tips">NO.1推荐：{{yourCommend.productName}}</div> -->
                <div class="tips"><img v-if="list.length > 0" src="../../../static/image/NO1.png" alt=""></div>
                <div class="bank-name">
                    <div v-for="(item,index) in yourCommend.capitalLogoList" :key="item+index" style="display:flex">
                        <div class="img_icon"><img height="20" :src="maxBankLogo" alt /></div>
                    </div>
                    <div class="name" style="margin-left: 5px">{{yourCommend.productName}}</div>
                </div>
                <div class="limit-container">
                    <h3 style="font-size:14px">最低利率 <span style="font-weight:600">{{yourCommend.loanRate}}%</span>（年化）</h3>
                    <div class="limit">{{yourCommend.quotaMax|formatter}}</div>
                </div>
                <div class="tags">
                    <div
                    class="tag"
                    v-for="(item, index) in yourCommend.productTags"
                    :key="'tags'+index"
                    >{{item}}</div>
                </div>
                <!-- <van-button class="max-button" :style="{color:buttonColor}" type="primary" @click="applyFor">立即办理</van-button> -->

                <van-button
                    class="max-button"
                    v-show="yourCommend.status==7"
                    :style="{color:buttonColor}"
                    type="primary"
                    @click.native.stop="handleApplyFor(yourCommend)"
                >{{yourCommend.productNature==1?'立即申请':'查看详情'}}</van-button>
                <van-button
                    class="max-button"
                    v-show="yourCommend.status==2 && yourCommend.productNature==1"
                    :style="{color:buttonColor}"
                    type="primary"
                    @click.native.stop="applyFor(yourCommend)"
                >用款</van-button>
                <van-button
                    class="max-button"
                    v-show="yourCommend.status==2 && yourCommend.productNature==0"
                    :style="{color:buttonColor}"
                    type="primary"
                    @click.native.stop="applyFor(yourCommend)"
                >用款</van-button>
                <van-button
                    class="max-button"
                    v-show="yourCommend.status==0 && yourCommend.productNature==1"
                    :style="{color:buttonColor}"
                    type="primary"
                    @click.native.stop="applyFor(yourCommend)"
                >办理中</van-button>
                <van-button
                    class="max-button"
                    v-show="yourCommend.status==0 && yourCommend.productNature==0"
                    :style="{color:buttonColor}"
                    type="primary"
                    @click.native.stop="shenheClickBtn"
                >审核中</van-button>
                <div class="provide_txt">本产品由{{yourCommend.capitalName}}提供</div>
                </div>
            </div>
      </div>

        <!-- 推荐列表产品 -->
        <financing-item2
        style="margin: 30px 15px;"
        v-for="(item, index) in list"
        :item="item"
        :index="index"
        :key="'financing2' + index"
        />
  </div>
</template>

<script>

export default {
  name: "LoanMatchingList",
  props: ['list', 'yourCommend'],
  data() {
    return {};
  },

  mounted() {
    // console.log(this.yourCommend)
  },

  filters: {
    formatter(num) {
      return (
        num &&
        num.toString().replace(/\d+/, function (s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
  },

  computed: {
      // 银行logo
    maxBankLogo() {
      if (this.yourCommend.capitalName == "中国农业银行") {
            return "/static/image/bank/logo/nongye.png";
        } else if (this.yourCommend.capitalName == "中国银行") {
            return "/static/image/bank/logo/zhongguo.png"
        } else if (this.yourCommend.capitalName == "重庆银行") {
            return "/static/image/bank/logo/chongqing.png"
        } else if (this.yourCommend.capitalName == "达州银行") {
            return "/static/image/bank/logo/dazhou.png"
        } else if (this.yourCommend.capitalName == "中国工商银行") {
            return "/static/image/bank/logo/gongshang.png"
        } else if (this.yourCommend.capitalName == "哈尔滨银行") {
            return "/static/image/bank/logo/haerbin.png"
        } else if (this.yourCommend.capitalName == "华夏银行") {
            return "/static/image/bank/logo/huaxia.png"
        } else if (this.yourCommend.capitalName == "徽商银行") {
            return "/static/image/bank/logo/huishang.png"
        } else if (this.yourCommend.capitalName == "京东数科") {
            return "/static/image/bank/logo/JDD.png"
        } else if (this.yourCommend.capitalName == "平安银行") {
            return "/static/image/bank/logo/pingan.png"
        } else if (this.yourCommend.capitalName == "遂宁银行") {
            return "/static/image/bank/logo/suining.png"
        } else if (this.yourCommend.capitalName == "兴业银行") {
            return "/static/image/bank/logo/xingye.png"
        } else if (this.yourCommend.capitalName == "中国邮政储蓄银行") {
            return "/static/image/bank/logo/youzheng.png"
        } else if (this.yourCommend.capitalName == "招联金融") {
            return "/static/image/bank/logo/zhaolian.png"
        } else if (this.yourCommend.capitalName == "招商银行") {
            return "/static/image/bank/logo/zhaoshang.png"
        } else if (this.yourCommend.capitalName == "交通银行") {
            return "/static/image/bank/logo/jiaotong.png"
        } else if (this.yourCommend.capitalName == "中国建设银行") {
            return "/static/image/bank/logo/jianshe.png"
        } else if (this.yourCommend.capitalName == "民生银行") {
            return "/static/image/bank/logo/minsheng.png"
        } else if (this.yourCommend.capitalName == "泸州银行") {
            return "/static/image/bank/logo/luzhou.png"
        } else if (this.yourCommend.capitalName == "天津银行") {
            return "/static/image/bank/logo/tianjin.png"
        } 
    },
      // 背景图片
    bankCardImage() {
      if (this.yourCommend.capitalName == "中国农业银行") {
            return "/static/image/bank/background/nongye.png";
        } else if (this.yourCommend.capitalName == "中国银行") {
            return "/static/image/bank/background/chinabank.png"
        } else if (this.yourCommend.capitalName == "重庆银行") {
            return "/static/image/bank/background/chongqing.png"
        } else if (this.yourCommend.capitalName == "达州银行") {
            return "/static/image/bank/background/dazhou.png"
        } else if (this.yourCommend.capitalName == "中国工商银行") {
            return "/static/image/bank/background/gongshang.png"
        } else if (this.yourCommend.capitalName == "哈尔滨银行") {
            return "/static/image/bank/background/haerbin.png"
        } else if (this.yourCommend.capitalName == "华夏银行") {
            return "/static/image/bank/background/huaxia.png"
        } else if (this.yourCommend.capitalName == "徽商银行") {
            return "/static/image/bank/background/huishang.png"
        } else if (this.yourCommend.capitalName == "京东数科") {
            return "/static/image/bank/background/JDD.png"
        } else if (this.yourCommend.capitalName == "平安银行") {
            return "/static/image/bank/background/pingan.png"
        } else if (this.yourCommend.capitalName == "遂宁银行") {
            return "/static/image/bank/background/suining.png"
        } else if (this.yourCommend.capitalName == "兴业银行") {
            return "/static/image/bank/background/xingye.png"
        } else if (this.yourCommend.capitalName == "中国邮政储蓄银行") {
            return "/static/image/bank/background/youzheng.png"
        } else if (this.yourCommend.capitalName == "招联金融") {
            return "/static/image/bank/background/zhaolian.png"
        } else if (this.yourCommend.capitalName == "招商银行") {
            return "/static/image/bank/background/zhaoshang.png"
        } else if (this.yourCommend.capitalName == "交通银行") {
            return "/static/image/bank/background/jiaotong.png"
        } else if (this.yourCommend.capitalName == "中国建设银行") {
            return "/static/image/bank/background/jianshe.png"
        } else if (this.yourCommend.capitalName == "民生银行") {
            return "/static/image/bank/background/minsheng.png"
        } else if (this.yourCommend.capitalName == "泸州银行") {
            return "/static/image/bank/background/luzhou.png"
        } else if (this.yourCommend.capitalName == "天津银行") {
            return "/static/image/bank/background/tianjin.png"
        } else {
            return "/static/image/bank/bjH5.png"
        }
    },
    // 按钮背景色
    buttonColor() {
      if (this.yourCommend.capitalName == "中国农业银行") {
        return "#15AEA3";
      } else if (this.yourCommend.capitalName == "中国银行") {
        return "#ad3a3f";
      } else if (this.yourCommend.capitalName == "重庆银行") {
        return "#e93c33";
      } else if (this.yourCommend.capitalName == "达州银行") {
        return "#8c6c40";
      } else if (this.yourCommend.capitalName == "中国工商银行") {
        return "#db2a32";
      } else if (this.yourCommend.capitalName == "哈尔滨银行") {
        return "#dc3e18";
      } else if (this.yourCommend.capitalName == "华夏银行") {
        return "#e7223d";
      } else if (this.yourCommend.capitalName == "徽商银行") {
        return "#ce252a";
      } else if (this.yourCommend.capitalName == "京东数科") {
        return "#3c73fe";
      } else if (this.yourCommend.capitalName == "平安银行") {
        return "#f56d3b";
      } else if (this.yourCommend.capitalName == "遂宁银行") {
        return "#2e779e";
      } else if (this.yourCommend.capitalName == "兴业银行") {
        return "#1254b0";
      } else if (this.yourCommend.capitalName == "中国邮政储蓄银行") {
        return "#1a9457";
      } else if (this.yourCommend.capitalName == "招联金融") {
        return "#3573D8";
      } else if (this.yourCommend.capitalName == "招商银行") {
        return "#e43131";
      } else if (this.yourCommend.capitalName == "交通银行") {
        return "#2f329a";
      } else if (this.yourCommend.capitalName == "中国建设银行") {
        return "#144b9c";
      } else if (this.yourCommend.capitalName == "民生银行") {
        return "#078dad"
      } else if (this.yourCommend.capitalName == "泸州银行") {
        return "#ba3a39"
      } else if (this.yourCommend.capitalName == "天津银行") {
        return "#005eb5";
      }
    },
  },

  methods: {
    // 查看详情
    handleApplyFor(itemObj) {
      localStorage.setItem("shisuanBack", window.location.href);
      this.$common.productDetailJump(itemObj)
      // this.$router.replace({
      //   path: "/financingDetail",
      //   query: { productNo: itemObj.productNo, status: itemObj.status, productNature: '1', loanLimit:itemObj.loanLimit },
      // });
    },

     // 申请
    applyFor(e) {
      var _this = this;
      // console.log(ptojectType)
      this.$common.infoSubmit(
        "/app/auth/status",
        { dkId: localStorage.getItem("dkId") },
        (res) => {
          // console.log(res)
          if (res.status == 0) {
            //未认证
            localStorage.setItem('isFirst', '')
            localStorage.setItem("livingToPage", window.location.href);
            _this.$refs.popup.isPageShow = true;
          } else {
            //已认证
            // this.$common.pageEventHandle({eventType: 11, productNo: itemObj.productNo});
            // this.$common.pageEventHandle({eventType: 12, productNo: itemObj.productNo});
            if (e.status == 7) {
              // _this.$common.getProjectUrl(itemObj.productNo, "shenqing");
              return
            } else {
              // console.log(1)
              if(e.productNature==1) {
                let vo = {productNo:e.productNo,dkId:localStorage.getItem("dkId")}
                _this.$common.getProjectUrl(vo, "yongkuan");
              } else if(e.productNature == 0) {
                localStorage.setItem("yongkuan", window.location.href);
                this.$router.replace({
                  path: "/financingDetail",
                  query: {capitalName: e.capitalName, loanLimit:e.loanLimit, productName: e.productName, creditStatusDesc: e.creditStatusDesc}
                });
              }
            }
            // this.$common.getData("/app/product/applyAgentProductAndUrl", {dkId:localStorage.getItem('dkId'),productNo:itemObj.productNo}, function (res) {
            //   // console.log(JSON.stringify(res));
            //   window.location.href=res;
            //   // window.open(res, "_blank");
            // });
          }
        }
      );
    },

    // 跳转融资记录
    shenheClickBtn: function () {
      localStorage.setItem("rzjlBack", window.location.href);
      this.$router.replace({ path: "/financingRecordsList" });
    },
  }

};
</script>

<style lang="less" scoped>

  .maxBox {
    // text-align: center;
    margin-top: 23px;
    .maxBox {
        margin-bottom: 30px;
    }
    h1 {
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      margin-top: 5px;
      margin-bottom: 10px;
    }
    .max-container {
      margin: 0 15px;
      height: 230px;
      position: relative;
      border-radius: 5px;
      .back-image {
        border-radius: 5px;
        width: 100%;
        height: 100%;
      }
      .bank-info {
        // padding-top: 13px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      .bank-name {
        font-size: 14px;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 20px;
        position: relative;
        margin-top: 10px;
        margin-right: 15px;
        .img_icon {
            // padding: 5px;
            border-radius: 28px;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
      }
      .tips {
        position: absolute;
        left: 10px;
        top: -10px;
        // padding: 4px 10px;
        // background: rgba(247, 232, 213, 1);
        // border-radius: 3px;
        // font-size: 11px;
        // font-weight: 400;
        // color: rgba(136, 73, 16, 1);
        img {
          width: 50px;
          height: 21px;
        }
      }
      img {
      }
      .limit-container {
        text-align: left;
        display: inline-block;
      }
      .tags {
        .tag {
          border: 1px solid rgba(255, 255, 255, .8);
          border-radius: 4px;
          padding: 0 4px;
          font-size: 10px;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          display: inline-block;
          margin-top: 10px;
          margin-right: 4px;
        }
      }
      .limit {
        font-size: 43px;
        font-weight: bold;
        color: #ffffff;
        margin-top: 5px;
        height: 38px;
        line-height: 38px;
        font-family: din;
      }
      h3 {
        font-size: 15px;
        font-weight: 300;
        color: #ffffff;
        margin-top: 10px;
      }
      .max-button {
        width: 200px;
        height: 32px;
        background: #ffffff;
        border-radius: 18px;
        border: none;
        font-size: 15px;
        font-weight: 500;
        color: #3c73fe;
        margin-top: 15px;
        font-weight: bold;
      }
    }
    .provide_txt {
      margin-top: 10px;
      font-size: 10px;
      font-family: PingFang SC;
      font-weight: 300;
      color: #FFFFFF;
      opacity: 0.62;
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/LoanMatchingList/index.vue